import Alpine from 'alpinejs';

Alpine.store('wishlist', {
    items: [],
    isLoaded: false,
    isLoading: false,

    has(listingId) {
        // Return false until data is loaded to show empty hearts initially
        if (!this.isLoaded) return false;
        return this.items.includes(parseInt(listingId, 10));
    },

    async toggle(listingId) {
        if (!listingId) return;

        // Optimistic update
        const id = parseInt(listingId, 10);
        const originallyHas = this.has(id);
        
        if (originallyHas) {
            this.items = this.items.filter(i => i !== id);
        } else {
            this.items.push(id);
        }

        try {
            const csrf = window.__csrfToken;
            if (!csrf) { console.error('CSRF token not available'); return; }

            const formData = new FormData();
            formData.append('listingId', id);
            formData.append(csrf.name, csrf.value);

            const response = await fetch('/actions/avari/wishlist/toggle', {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                }
            });

            const data = await response.json();

            if (!data.success) {
                // Revert on failure
                console.error("Wishlist toggle failed:", data.message);
                if (originallyHas) {
                    this.items.push(id);
                } else {
                    this.items = this.items.filter(i => i !== id);
                }
            } else {
                // Sync from server response if needed, 
                // but optimistic update is usually enough.
            }

        } catch (error) {
            console.error("Wishlist toggle error:", error);
            // Revert
            if (originallyHas) {
                this.items.push(id);
            } else {
                this.items = this.items.filter(i => i !== id);
            }
        }
    }
});
